import firebase from "firebase/compat/app";
import "firebase/compat/auth";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "movie-list-17049.firebaseapp.com",
  projectId: "movie-list-17049",
  storageBucket: "movie-list-17049.appspot.com",
  messagingSenderId: "498983789377",
  appId: "1:498983789377:web:06100bf42b6db4e18937c0",
  databaseURL:
    "https://movie-list-17049-default-rtdb.europe-west1.firebasedatabase.app/",
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();

const provider = new firebase.auth.GoogleAuthProvider();
provider.setCustomParameters({ prompt: "select_account" });
export const signInWithGoogle = () => auth.signInWithPopup(provider);

export default firebase;
